import React from "react";
import Modal from "@mui/material/Modal";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import CloseIcon from "@mui/icons-material/Close";
import AccessibleIconButton from "components/base/AccessibleIconButton";
import { List, ListItem, ListItemText } from "@mui/material";

const modalStyle = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: { xs: "90vw", sm: "60vw", md: "45vw" },
    bgcolor: "background.paper",
    boxShadow: 24,
    borderRadius: 2,
    outline: "none",
};

const ReferralTermsModal = ({ isOpen, onClose }) => {
    const terms = [
        "Your credits will not appear until payment is made by friends using your referral code.",
        "Your credit will be equal to 10% of the amount paid by your friends.",
        "Discounts will only apply towards annual subscriptions purchased by your friends.",
        "Your credits will rollover annually and are uncapped.",
        "You can accumulate credits while you are on a free trial (but may not appear until payment is made by your friends).",
        "Your credits will be applied to future subscription purchases and cannot be used in conjunction with other discounts you may be eligible for.",
    ];

    return (
        <Modal open={isOpen} onClose={onClose}>
            <Box sx={modalStyle}>
                <Box sx={{ p: 4, position: "relative" }}>
                    <Typography
                        variant="h4"
                        component="div"
                        color="#406da4"
                        fontWeight="600"
                    >
                        Referral Terms and Conditions
                    </Typography>
                    <AccessibleIconButton
                        title="Close"
                        onClick={onClose}
                        sx={{ position: "absolute", right: 8, top: 8 }}
                    >
                        <CloseIcon />
                    </AccessibleIconButton>

                    <List sx={{ pt: 0 }}>
                        {terms.map((term, index) => (
                            <ListItem key={index} sx={{ px: 0, alignItems: "flex-start" }}>
                                <ListItemText
                                    primary={term}
                                    slotProps={{ primary: { variant: "body2" } }}
                                />
                            </ListItem>
                        ))}
                    </List>
                </Box>
            </Box>
        </Modal>
    );
};

export default ReferralTermsModal;
